import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";
import { spaceApi } from "@circle-react/api";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { SpaceResource } from "@circle-react/types/Space";

export const SPACE_SHOW_REQUEST_KEY = "space-show";

interface UseSpaceResourceOptions {
  queryOptions?: UseQueryOptions<SpaceResource, ApiError>;
  spaceId?: number;
}

type UseSpaceResourceReturn = UseQueryResult<SpaceResource, ApiError> & {
  space: SpaceResource | undefined;
};

export const useSpaceResource = ({
  spaceId,
  queryOptions = {},
}: UseSpaceResourceOptions): UseSpaceResourceReturn => {
  const queryKey = [SPACE_SHOW_REQUEST_KEY, spaceId];
  const fetchSpace = (): Promise<SpaceResource> =>
    spaceApi.show<SpaceResource>({
      id: spaceId,
      forReactQuery: true,
    }) as Promise<SpaceResource>;

  const query = useQuery<SpaceResource, ApiError>(queryKey, fetchSpace, {
    enabled: Boolean(spaceId),
    ...queryOptions,
  });

  return {
    ...query,
    space: query.data,
  };
};
